import React from "react"
import agentAssets from "../../../assets/assets_agent.jpg"
import { Button } from "@material-tailwind/react"

function AgentMain ({

}) {
    return (
        <section className="px-0 mt-12 mb-8 md:mt-24 md:mb-24">
            <div className="grid grid-cols-1 md:grid-cols-2 items-center">
                <div>
                    <div className="font-bold text-[30px]">Kenapa Agent Maxx Property ?</div>
                    <div>Agen kami akan memberikan solusi untuk pencarian rumah kamu</div>
                    <div className="hidden mt-8 md:block max-w-[200px]">
                        <Button className="bg-gold w-full" onClick={() => {
                            window.location.href = "/agents"
                        }}>Lihat Agen Kami</Button>
                    </div>
                </div>
                <div className="p-8">
                    <img className="w-[100%]" src={agentAssets}/>
                </div>
                <div className="md:hidden">
                    <Button className="bg-gold w-full" onClick={() => {
                        window.location.href = "/agents"
                    }}>Lihat Agen Kami</Button>
                </div>
            </div>
        </section>
    )
}

export default AgentMain